var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "input-group-prepend col-md-12"
  }, [_c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changeStatus == '1' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    attrs: {
      "type": "radio",
      "id": "changeStatus",
      "name": "changeStatus"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.changeStatus, 1)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Search By Filters ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changeStatus == '0' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    attrs: {
      "type": "radio",
      "id": "changeStatus",
      "name": "changeStatus"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.changeStatus, 0)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Search By Shipping ID ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changeStatus == '2' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeStatus),
      expression: "changeStatus"
    }],
    attrs: {
      "type": "radio",
      "id": "changeStatus",
      "name": "changeStatus"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.changeStatus, 2)
    },
    on: {
      "click": _vm.clearAll,
      "change": function($event) {
        _vm.changeStatus = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Search By Assign Batch No")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchdata.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 0),
      expression: "changeStatus == 0"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 0 ? 'required|VerifyShippingid' : ''),
      expression: "changeStatus == 0 ? 'required|VerifyShippingid':''"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingID / AWB",
      "name": "ShippingID",
      "id": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShippingID')),
      expression: "errors.has('ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShippingID')))]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("Note:Please enter comma separated without space shipping IDs, upto limit 50 .")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 2),
      expression: "changeStatus == 2"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignBatchNo),
      expression: "assignBatchNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 2 ? 'required' : ''),
      expression: "changeStatus == 2 ? 'required': '' "
    }],
    ref: "textarea1",
    staticClass: "col-md-12 form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('assignBatchNo')
    },
    staticStyle: {
      "width": "96%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter assignbatch",
      "rows": "3",
      "name": "assignBatchNo",
      "id": "assignBatchNo"
    },
    domProps: {
      "value": (_vm.assignBatchNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assignBatchNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('assignBatchNo')),
      expression: "errors.has('assignBatchNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('assignBatchNo')))])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1),
      expression: "changeStatus == 1"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzone),
      expression: "hubzone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('hubzone')
    },
    attrs: {
      "name": "hubzone",
      "id": "hubzone",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.getHubListByZone()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubZoneList), function(zone_obj) {
    return _c('option', {
      domProps: {
        "value": zone_obj.hubzoneid
      }
    }, [_vm._v(_vm._s(zone_obj.hubzonename))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubzone')),
      expression: "errors.has('hubzone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Zone")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : ''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('hubname')
    },
    attrs: {
      "name": "hubname",
      "id": "hubname",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.getUserList()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubServiceCenterList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubID
      }
    }, [_vm._v(_vm._s(hub_obj.HubName) + " ( " + _vm._s(hub_obj.HubID) + " )")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubname')),
      expression: "errors.has('hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Hub")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : ''"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientList,
      "selected-option": _vm.clientItemObj,
      "name": "client",
      "placeholder": "Select client"
    },
    on: {
      "select": _vm.getclients
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('client')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : ''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentType')
    },
    attrs: {
      "name": "shipmentType",
      "id": "shipmentType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shipmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setFileType]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.shipmentTypeList), function(shipmentType_obj) {
    return _c('option', {
      domProps: {
        "value": shipmentType_obj.businessconfig
      }
    }, [_vm._v(_vm._s(shipmentType_obj.businessconfig))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentType')),
      expression: "errors.has('shipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select shipmentType")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1),
      expression: "changeStatus == 1"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileType),
      expression: "fileType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : ''"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "fileType",
      "id": "fileType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fileType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.fileTypeArray), function(file) {
    return _c('option', {
      domProps: {
        "value": file
      }
    }, [_vm._v(_vm._s(file))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fileType')),
      expression: "errors.has('fileType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select File Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(7), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changeStatus == 1 ? 'required' : ''),
      expression: "changeStatus == 1 ? 'required' : ''"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.users,
      "selected-option": _vm.userObj,
      "name": "userID",
      "placeholder": "Select user"
    },
    on: {
      "select": _vm.getdeliveyList
    },
    model: {
      value: (_vm.userID),
      callback: function($$v) {
        _vm.userID = $$v
      },
      expression: "userID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('userID')),
      expression: "errors.has('userID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select User ID")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Delivery Start Date :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.startDate),
      expression: "dateobj.startDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('startDate')
    },
    attrs: {
      "id": "startDate",
      "type": "Date",
      "name": "startDate"
    },
    domProps: {
      "value": (_vm.dateobj.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "startDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.startDate')),
      expression: "errors.has('form-2.startDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Start Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Delivery End Date :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.endDate),
      expression: "dateobj.endDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('endDate')
    },
    attrs: {
      "id": "endDate",
      "type": "Date",
      "name": "endDate"
    },
    domProps: {
      "value": (_vm.dateobj.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "endDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.endDate')),
      expression: "errors.has('form-2.endDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select End Date")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeStatus == 1),
      expression: "changeStatus == 1"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" Net Amount :")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.netAmt),
      expression: "netAmt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^\d*\.?\d*$/
      }),
      expression: "{ regex: /^\\d*\\.?\\d*$/ }"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('netAmt')
    },
    attrs: {
      "id": "netAmt",
      "name": "netAmt"
    },
    domProps: {
      "value": (_vm.netAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.netAmt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netAmt')),
      expression: "errors.has('netAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Invalid Net Amount !!")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.SearchLoading
    },
    on: {
      "update:active": function($event) {
        _vm.SearchLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary leftmar",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Disply On Screen ")]), _vm._v(" "), (_vm.changeStatus != 2) ? _c('button', {
    staticClass: "btn btn-sm btn-primary leftmar",
    on: {
      "click": _vm.emailPOD
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Email POD ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clearAll
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clearAll
    }
  }), _vm._v(" Clear ")])], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchFlag),
      expression: "searchFlag"
    }],
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(8), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [(_vm.ScanPODList == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ScanPODList), function(val, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.HubZoneName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.HubName) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.HubId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DeliveryType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.UpdateFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.deliveryDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.PODUploadedDate))]), _vm._v(" "), (val.PODPath && val.PODPath.length > 0) ? _c('td', _vm._l((val.PODPath), function(data, i) {
      return _c('tr', [_c('span', {
        staticClass: "link",
        on: {
          "click": function($event) {
            return _vm.getImage(data)
          }
        }
      }, [_vm._v("Image" + _vm._s(i + 1))])])
    }), 0) : _c('td', [_vm._m(10, true)])])
  })], 2)]), _c('br')])])]), _vm._v(" "), _c('div', [_c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ScanPODList != 0),
      expression: "ScanPODList != 0"
    }],
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchAssignBatch),
      expression: "searchAssignBatch"
    }],
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(11), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', [(_vm.ScanPODAssignBatchList == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ScanPODAssignBatchList), function(val, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DeliveryType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(val.DeliveryDate)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.DeliveryUserID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.AssignBatchNo))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getImage(val.ImagesPath)
        }
      }
    }, [_vm._v(" POD Image")])])])
  })], 2)]), _c('br')])])]), _vm._v(" "), _c('div')])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Shipping IDs : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" AssignBatch No. : "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Zone :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Hub :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Client :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Shipment Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Type :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("User ID :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Scan POD List")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr. No. ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Zone  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OrderType  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("HubID  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DeliveryType  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShipAddress  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShipPincode  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UpdateFrom  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DeliveryDate  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("POD Uploaded date  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("POD Image  ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('span', [_vm._v("PODPath not found")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Scan POD List")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr. No. ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Delivery Type   ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery User ID  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Assign Batch No.  ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("POD Path  ")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aea2568","hasScoped":true}!./src/views/components/ScanPODSheet/ScanPODReport/ScanPODReport.component.html
// module id = 1153
// module chunks = 1